import React from "react"
import ContactForm from "../../../components/ContactForm"
import WorkCard from "../../../components/WorkCard/Index"
import Link from "../../../utils/link"

const HomeWork = (props) => {

    const blok = props.blok

    // kh missed title for work section
    // kh typo in cms, should be blocks

    const blocks = blok.selected_work

    return (
        <section className="width pb-11 lg:pb-10">
            {blok.title != "" && (
                <h2 className="uppercase text-lg border-t border-black py-4">
                    {blok.title}
                </h2>

            )}

            <ol className="grid lg:grid-cols-2 gap-8 lg:gap-6">
                {blocks.map((block, index) => {

                    if (block.component == "contact_work_dummy") {
                        return (
                            <li key={`home-work-${index}`} className='lg:col-span-2 order-last lg:order-[unset]'>
                                <ContactForm/>
                            </li>
                        )
                    }

                    if (block.component == "mobile_cta") {
                        return (
                            <li key={`home-work-${index}`} className='w-full lg:hidden'>
                                <Link to={block.link?.cached_url} className='btn'>
                                  {block.mobile_cta}
                                </Link>
                            </li>
                        )
                    }



                    if (block.component == "work_item") {
                        return (
                            <WorkCard block={block} key={`home-work-${index}`} />
                        )
                    }
                })}
            </ol>
        </section>
    )
}

export default HomeWork